import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Backend from "./backend/Backend";
import FrontendRoute from "./frontend/FrontendRoute";
import { useEffect, useRef, useState } from "react";
import { setLoadingFunctions } from "./http/HttpRequest";
import LoadingBar from "react-top-loading-bar";

function App() {
  const topLoadingBarRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setLoadingFunctions({
      startLoading: () => {
        setIsLoading(true);
        if (topLoadingBarRef.current) {
          topLoadingBarRef.current.continuousStart();
        }
      },
      completeLoading: () => {
        setIsLoading(false);
        if (topLoadingBarRef.current) {
          topLoadingBarRef.current.complete();
        }
      },
    });
  }, []);

  return (
    <>
      <LoadingBar ref={topLoadingBarRef} color="#a83232" />
      <Router>
        <Routes>
          <Route path="/*" element={<FrontendRoute />} />
          <Route path="/root/*" element={<Backend />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
